import { isMeterTieredUsageFeeCategory } from './usageFeeCategoryMatching';

export type FeeBillingTiming = 'PREPAID' | 'POSTPAID';
function inferBillingTiming(
  feeCode?: string | null,
  feeName?: string | null,
): FeeBillingTiming {
  if (isMeterTieredUsageFeeCategory({ feeCode, name: feeName })) {
    return 'POSTPAID';
  }
  return 'PREPAID';
}

export function resolveBillingTiming(
  explicit?: FeeBillingTiming | null,
  feeCode?: string | null,
  feeName?: string | null,
): FeeBillingTiming {
  const inferred = inferBillingTiming(feeCode, feeName);
  if (inferred === 'POSTPAID') return 'POSTPAID';
  if (explicit) return explicit;
  return inferred;
}

export function getPreviousBillingPeriod(period: string): string {
  const normalized = period.replace(/^Tháng\s+/i, '').trim();
  const [monthStr, yearStr] = normalized.split('/');
  let month = parseInt(monthStr, 10);
  let year = parseInt(yearStr, 10);
  if (month === 1) {
    month = 12;
    year -= 1;
  } else {
    month -= 1;
  }
  return `${String(month).padStart(2, '0')}/${year}`;
}

export function resolveInvoiceBillingPeriod(
  noticePeriod: string,
  timing: FeeBillingTiming,
): string {
  if (timing === 'POSTPAID') {
    return getPreviousBillingPeriod(noticePeriod);
  }
  return noticePeriod;
}

export function resolveCategoryInvoicePeriod(
  noticePeriod: string,
  category: {
    billingTiming?: FeeBillingTiming | null;
    feeCode?: string | null;
    name?: string | null;
  },
): string {
  const timing = resolveBillingTiming(category.billingTiming, category.feeCode, category.name);
  return resolveInvoiceBillingPeriod(noticePeriod, timing);
}

export function describeNoticePeriodSummary(noticePeriod: string): string {
  const utilityPeriod = getPreviousBillingPeriod(noticePeriod);
  return `Kỳ thu phí ${noticePeriod}: phí quản lý/xe/thẻ/khác (hóa đơn ${noticePeriod}), phí điện/nước (hóa đơn ${utilityPeriod})`;
}
